import React from "react";
import { Typography } from "antd";
import dayjs from "dayjs";

const CancellationPolicyHotel = ({ policyData }) => {
    const { Text } = Typography;
    if (!policyData) return null;
    const policyItems = policyData.split('|#!#').filter(item => item.trim() !== '');

    const formatPolicy = (policyText) => {
        const dateRegex = /\b(\d{2}-[a-zA-Z]{3}-\d{4} \d{2}:\d{2}:\d{2})\b/g;
        return policyText.replace(dateRegex, (match) => {
            return dayjs(match, "DD-MMM-YYYY HH:mm:ss").format("DD MMM YYYY, hh:mm A");
        });
    };

    return (
        <div className="mt-2 mb-0">
            {policyItems.map((item, index) => (
                <Text key={index} style={{ display: 'block' }}>
                    {formatPolicy(item)}
                </Text>
            ))}
        </div>
    );
};

export default CancellationPolicyHotel
